module.exports = __webpack_public_path__ + "media/stylesheets/images/marker-icon-2x-green-ee4952514313dab2342656884a622887.png";